












































































import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { defineComponent, toRefs, computed } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    disabled: { type: Boolean, default: false },
    selected: { type: Boolean, default: false },
    vertical: { type: Boolean, default: false },
    round: { type: Boolean, default: false },
    completed: { type: Boolean, default: false },
    previousCompleted: { type: Boolean, default: false },
    index: { type: Number, default: null },
    selectedIndex: { type: [Number, Boolean], default: null },
    stepNumber: { type: Boolean, default: false },
    totalSteps: { type: Number, default: 0 },
    static: { type: Boolean, default: false },
    showLabel: { type: Boolean, default: true }
  },
  setup(props, { emit }) {
    const {
      disabled,
      index,
      selectedIndex,
      selected,
      completed,
      totalSteps,
      previousCompleted,
      vertical
    } = toRefs(props)

    const paintBefore = computed(() => {
      if (vertical.value && previousCompleted.value) {
        return true
      } else if (selectedIndex.value) {
        return (
          (selected.value && index.value === selectedIndex.value) ||
          (!selected.value && index.value < selectedIndex.value)
        )
      } else if (selectedIndex.value === 0) {
        return index.value === 0
      } else {
        return null
      }
    })

    const paintAfter = computed(() => {
      if (vertical.value && completed.value) {
        return true
      }
      if (props.static) {
        return selectedIndex.value > index.value
      }

      if (index.value === selectedIndex.value) {
        return false
      }

      return (
        (!selected.value && index.value < selectedIndex.value) ||
        (selected.value && selectedIndex.value === totalSteps.value - 1)
      )
    })

    const paintStep = computed(() => {
      if (props.static && selected.value) {
        return true
      }

      return (
        (completed.value && !selected.value) ||
        (selectedIndex.value &&
          !selected.value &&
          index.value < selectedIndex.value)
      )
    })

    const paintLabel = computed(() => {
      if (props.static) {
        return (
          typeof selectedIndex.value === 'number' &&
          index.value <= selectedIndex.value
        )
      }

      return selected.value
    })

    const handleStepClick = () => {
      if (disabled.value) {
        return
      }

      emit('click', index.value)
    }

    return {
      handleStepClick,
      faCheck,
      paintBefore,
      paintAfter,
      paintStep,
      paintLabel
    }
  }
})
